import api from '.'

export default {
    
    /**
     * Get wallet transactions
     * @param params
     */
    get(params) {
        return api
            .get(`/walletTransactions`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show wallet transaction
     * @param walletId
     * @param params
     */
    show(walletId, params) {
        return api
            .get(`/walletTransactions/${walletId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update wallet transaction
     * @param walletId
     * @param data
     */
    update(walletId, data) {
        return api
            .put(`/walletTransactions/${walletId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Cancel wallet transaction
     * @param walletId
     * @param data
     */
    cancel(walletId, data) {
        return api
            .post(`/walletTransactions/${walletId}/cancel`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Extend a wallet transaction
     * @param walletId
     * @param data
     */
    extend(walletId, data) {
        return api
            .post(`/walletTransactions/${walletId}/extend`, data)
            .then(response => {
                return response.data
            })
    },
}
